import debounce from 'lodash/debounce';
import { handleWindowScrollDirection } from '../../../scripts/utils/handleWindowScrollDirection';
import Vue from '../../../assets/vue';
import { setMaxHeightStyle } from '../../../scripts/utils/setMaxHeightStyle';

const { products, productsMeta } = window.productsConfig;
const INTEGRATOR_PAGE_PATH = '/pages/builders-find-a-brilliant-integrator';

const productBuyBannerComponent = ({
  productId,
  variantId,
  productsList = [],
  swatchesList,
  isPOEProduct = false,
  isVariantActiveAvailable,
  formattedSalePrice,
  hasCrossedPrice = null,
  formattedNetPrice,
  submitButtonText,
}) => ({
  data() {
    const productActive = products[productId];
    const variantActive = findVariant(productActive.variants, variantId);

    this.isComponentCreated = false;

    return {
      isActiveDropdown: false,
      isVariantActiveAvailable,
      productActive,
      variantActive,
      productsList,
      swatchesList,
      isPOEProduct,
      formattedSalePrice,
      hasCrossedPrice,
      formattedNetPrice,
      submitButtonText,
    };
  },
  computed: {
    productActiveMeta() {
      return productsMeta[this.productActive.id];
    },
    isVisibleProductsList() {
      return this.productsList.length > 1;
    },
    isVisibleSwatches() {
      return this.swatchesList.length > 1;
    },
    variantTitle() {
      return this.productActiveMeta.buyBannerTitle;
    },
    variantShortTitle() {
      return this.productActiveMeta.buyBannerTitleShort;
    },
  },
  methods: {
    redirectToIntegratorPage() {
      window.open(INTEGRATOR_PAGE_PATH, '_blank', 'noopener,noreferrer');
    },
    isVariantActive(id) {
      return String(id) === String(this.variantActive.id);
    },
    isProductActive(id) {
      return String(id) === String(this.productActive.id);
    },
    changeVariant(id) {
      const selectedColorPicker = document.querySelector(
        `[data-product-base-choose-color-panel-swatch='${id}']`
      );

      if (selectedColorPicker) {
        selectedColorPicker.click();
      }
    },
    changeProduct(id) {
      const selectedSwitchControl = document.querySelector(
        `[data-additional-product-switch-btn='${id}']`
      );

      if (selectedSwitchControl) {
        selectedSwitchControl.click();
      }
    },
    toggleProductsList() {
      this.isActiveDropdown = !this.isActiveDropdown;
    },
    addToCard() {
      if (this.isPOEProduct) {
        this.redirectToIntegratorPage();
        return;
      }

      const activeButton = document.querySelector('[data-add-to-cart-submit]');

      if (activeButton) {
        activeButton.click();
      }
    },
    updateBannerStates({
      newProductId,
      newVariantId,
      newProductsList = [],
      newSwatchesList = [],
      newFormattedSalePrice,
      hasNewCrossedPrice = null,
      newFormattedNetPrice,
      isNewVariantAvailable,
      newSubmitButtonText,
    }) {
      this.productActive = products[newProductId];
      this.variantActive = findVariant(
        this.productActive.variants,
        newVariantId
      );
      this.swatchesList = newSwatchesList;
      this.isVariantActiveAvailable = isNewVariantAvailable;
      this.productsList = newProductsList;
      this.formattedSalePrice = newFormattedSalePrice;
      this.hasCrossedPrice = hasNewCrossedPrice;
      this.formattedNetPrice = newFormattedNetPrice;
      this.submitButtonText = newSubmitButtonText;

      this.$forceUpdate();
    },
  },
  created() {
    this.isComponentCreated = true;
  },
  mounted() {
    handleWindowScrollDirection(
      () => {
        this.isActiveDropdown = false;
        changeBannerVisibility(false);
      },
      () => {
        changeBannerVisibility(true);
      },
      200
    );

    addMaxHeightToControlsDropdown();
  },
});

function changeBannerVisibility(show = true) {
  const bannerSelector = '[data-product-buy-banner]';
  const bannerEl = document.querySelector(bannerSelector);

  if (show) {
    bannerEl.setAttribute('data-show', true);
  } else {
    bannerEl.setAttribute('data-show', false);
  }
}

function findVariant(variants, variantId) {
  return variants?.find((variant) => String(variant.id) === String(variantId));
}

function addMaxHeightToControlsDropdown() {
  setMaxHeightStyle('[data-product-buy-banner-controls-dropdown-list]');
}

export const initProductBuyBanner = (bannerConfig) => {
  window.addEventListener(
    'resize',
    debounce(addMaxHeightToControlsDropdown, 50)
  );

  if (document.querySelector('#product-buy-banner')) {
    window.productBuyBanner = new Vue(
      productBuyBannerComponent(bannerConfig)
    ).$mount('#product-buy-banner');
  }
};

export const showBannerSpinner = (isLoading) => {
  const buyBannerControlSubmit = document.querySelector(
    `[data-product-buy-banner-controls-submit-snipper]`
  );

  if (buyBannerControlSubmit) {
    buyBannerControlSubmit.setAttribute(
      'data-loading',
      isLoading ? 'true' : 'false'
    );
  }
};
